import { styled } from "styled-components";

import { StarIcon, UIButton } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";

const StyledStarIcon = styled(StarIcon)`
  height: 16px;
  margin-left: 10px;
`;

type CreateCustomKeyIssueButtonProps = { className?: string; onAdd: () => void; showStarIcon: boolean };

export const CreateCustomKeyIssueButton = ({ onAdd, showStarIcon }: CreateCustomKeyIssueButtonProps) => {
  const translate = useTranslate();

  return (
    <UIButton
      data-test-id="create-custom-key-issue-button"
      onClick={() => onAdd()}
      title={translate("app.custom_key_issue.create_button.help_text")}
    >
      {translate("app.custom_key_issue.add_issue")}
      {showStarIcon && <StyledStarIcon />}
    </UIButton>
  );
};
